import {
  Component,
  ElementRef,
  OnInit,
  ViewChild
} from '@angular/core';

@Component({
  selector: 'app-partners',
  templateUrl: './partners.component.html',
  styleUrls: ['./partners.component.css'],
})
export class PartnersComponent implements OnInit {
  @ViewChild('partners') partners: ElementRef;
  items = [
    {
      src: 'anex.png',
      link: 'https://www.anextour.com/',
      alt: 'ANEX tour',
      width: 215,
      height: 83
    },
    {
      src: 'tui.png',
      link: 'http://tui.ru/',
      alt: 'Tui',
      width: 189,
      height: 83
    },
    {
      src: 'top-hotels.png',
      link: 'https://tophotels.ru/',
      alt: 'TOP Hotels',
      width: 263,
      height: 78
    },
    {
      src: 'space-travel.svg',
      link: 'https://space-travel.ru',
      alt: 'Space Travel',
      width: 261,
      height: 70
    },
    {
      src: 'tez-tour.png',
      link: 'https://www.tez-tour.com/',
      alt: 'TEZ tour',
      width: 267,
      height: 78
    },
    {
      src: 'pegas.svg',
      link: 'https://pegast.ru/',
      alt: 'Pegas touristik',
      width: 246,
      height: 78
    },
    {
      src: 'intourist.svg',
      link: 'https://intourist.ru/',
      alt: 'Intourist',
      width: 260,
      height: 53
    },
    {
      src: 'biblio-globus.png',
      link: 'https://www.bgoperator.ru/',
      alt: 'Библио Глобус',
      width: 266,
      height: 48
    }
  ];

  constructor() {}



  ngOnInit(): void {}
}
